import { useMemo } from 'react'
import { Asset, createAsset, SmpteTimestamp } from '@/organisms/AngelPlayer'
import { ContentVideo } from '@/services/ProjectsService/types'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'

export interface useVideoAssetProps {
  projectSlug: string
  video?: ContentVideo
}

export interface VideoAsset {
  guid: string
  slug: string
  title: string
  subtitle: string
  url: string
  duration: number
  watchPosition?: WatchPosition
}

interface WatchPosition {
  position: number
}

interface AssetResponse {
  asset?: Asset
}

export const useVideoAsset = ({ projectSlug, video }: useVideoAssetProps): AssetResponse => {
  const { query } = useSafeRouter()

  const asset = useMemo(() => {
    if (!video) {
      return
    }

    const videoTitle = video?.name ?? video?.title
    const smpte = query.smpte as SmpteTimestamp

    return createAsset({
      guid: video.id,
      projectSlug,
      slug: video?.project?.slug ?? '',
      name: videoTitle ?? '',
      url: video.url ?? '',
      title: videoTitle ?? '',
      subtitle: video?.description ?? video?.title ?? '',
      position: smpte ?? video?.watchPosition?.position ?? 0,
      duration: video?.duration ?? 0,
      videoType: 'video',
    })
  }, [query?.smpte, projectSlug, video])

  return { asset }
}
